
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Innovacrystacabforcorporate() {



    const cardData =
    {
        keyword: 'Innova Crysta Cab for Corporate',
        heading: 'Meghana Cab : Innova Crysta Cab for Corporate',
        headingDescription: 'Meghana Cab offers Innova Crysta Cab for Corporate, delivering a premium and professional travel solution tailored to meet the needs of business executives, employees, and VIP clients. Whether it is for daily office commutes, airport transfers, business meetings, or outstation conferences, our Innova Crysta vehicles provide the perfect blend of luxury, comfort, and efficiency.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732, Shaniwar Wada was once the grand seat of the Peshwas of the Maratha Empire. Though much of it was destroyed in a fire in 1828, the surviving gates and foundations tell a story of Maratha glory and political intrigue. The Delhi Darwaza (main gate) is especially impressive, and the palace grounds include fountains, courtyards, and the ruins of what was once a seven-storeyed palace. An evening light-and-sound show narrates the fort’s rich history and adds dramatic depth to the visitor experience."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a majestic building with Italian arches and sprawling gardens. Constructed in 1892 to support famine relief efforts, it later became a symbol of India's freedom struggle when Mahatma Gandhi, his wife Kasturba, and his secretary Mahadev Desai were imprisoned here. The palace now houses a museum with rare photos and belongings of the Gandhis, and the serene grounds contain the samadhis of Kasturba Gandhi and Mahadev Desai."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Located about 30 km from Pune, Sinhagad Fort sits atop the Sahyadri Hills at an elevation of 1,317 meters. This ancient hill fortress is most famous for the 1670 Battle of Sinhagad, where Tanaji Malusare fought valiantly for the Marathas. Visitors enjoy panoramic views, rustic food stalls serving bhakri and thecha, and scenic trekking routes. The fort is also dotted with historical points like Tanaji’s memorial and Kalyan Darwaza."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Nestled in Koregaon Park, the Osho Meditation Resort is a globally known center for wellness, meditation, and spiritual healing. Spread across beautifully landscaped gardens and modern zen-style halls, it offers courses in dynamic meditation, therapies, and holistic wellness. It’s not just a spiritual retreat but also a tranquil escape from city life for travelers seeking silence and rejuvenation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Carved out of a single basalt rock in the 8th century, Pataleshwar Cave Temple is a monolithic shrine dedicated to Lord Shiva. Located in the heart of the city near Jangli Maharaj Road, it features intricately carved pillars, a circular Nandi mandap, and a peaceful atmosphere that contrasts sharply with the urban chaos around it. It is a protected monument under the Archaeological Survey of India."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This museum houses over 20,000 rare artifacts collected by Dr. Dinkar Kelkar in memory of his son. From musical instruments and weaponry to sculptures and paintings, it showcases India’s rich cultural heritage in a way that’s both educational and immersive. A recent upgrade added multilingual audio guides, making it an excellent experience for all age groups and tourists."
  },
  {
    "title": "Dagadusheth Halwai Ganapati Temple",
    "description": "One of the most revered temples in Pune, Dagadusheth Halwai Ganapati is known for its massive idol of Lord Ganesha, adorned with gold and silver. The temple is particularly festive during Ganesh Chaturthi, when thousands visit to witness the elaborate decorations, music, and bhajan events. Located in the busy Budhwar Peth area, the temple remains a symbol of devotion and community spirit year-round."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Rising 2,100 feet above sea level, Parvati Hill is Pune’s second-highest point and offers a panoramic view of the city. The hill is crowned by a group of ancient temples built during the Peshwa era, including the Devdeveshwar Temple dedicated to Shiva and Parvati. A 103-step climb leads to this peaceful spiritual site, and a small museum nearby offers insight into Peshwa-era history and culture."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Garden)",
    "description": "Modeled after the famous Okayama Korakuen Garden in Japan, this is one of the largest Japanese-style gardens outside Japan. Spread over 10 acres, it features manicured lawns, natural water flows, elegant bridges, and flower beds that create a peaceful, Zen-like experience. It’s a popular destination for evening walks, photography, and family outings."
  },
  {
    "title": "Rajiv Gandhi Zoological Park (Katraj Zoo)",
    "description": "Spread across 130 acres, this modern zoological park houses a snake park, zoo, and a rescue center for injured animals. It is home to a wide variety of fauna including leopards, elephants, crocodiles, and Indian cobras. It’s a great educational destination for children and families, with ample greenery and shaded pathways for a relaxed experience."
  }
],

  "services": [
    {
      "name": "Corporate Innova Crysta Cab Pune",
      "description": "Book premium Corporate Innova Crysta cabs in Pune for executive travel, business visits, team movement, and outstation corporate trips. Our fleet of well-maintained vehicles comes with experienced chauffeurs, punctual service, and business-class comfort—ideal for impressing clients and ensuring employee convenience."
    },
    {
      "name": "Business Innova Crysta Taxi Pune",
      "description": "Ensure a seamless and professional business travel experience with our Innova Crysta taxis in Pune. Designed for executives and corporate teams, this service delivers a smooth, reliable, and refined commute between offices, meetings, and industrial hubs."
    },
    {
      "name": "Office Travel Innova Crysta Pune",
      "description": "Upgrade your daily office travel with our Innova Crysta cab services in Pune. Offering plush seating, air-conditioned comfort, and consistent punctuality, it's the ideal solution for employee commutes, inter-office travel, or day-long client visits."
    },
    {
      "name": "Chauffeur Driven Corporate Innova Crysta Pune",
      "description": "Experience hassle-free travel with our chauffeur-driven corporate Innova Crysta service. Our drivers are trained in etiquette, road safety, and punctuality—making this the preferred choice for CEOs, visiting delegates, and high-level executives."
    },
    {
      "name": "Corporate Event Innova Crysta Cab Booking Pune",
      "description": "Planning a business event in Pune? Book multiple Innova Crysta cabs for seamless transportation of guests, clients, or teams. We offer flexible packages for seminars, product launches, conferences, and team offsites, ensuring professional service and group comfort."
    },
    {
      "name": "Corporate Outstation Innova Crysta Hire Pune",
      "description": "Hire Innova Crysta for corporate outstation travel from Pune. Whether it’s a business trip to Mumbai, Nashik, or Bangalore, our outstation packages include fuel, tolls, and experienced chauffeurs to ensure your team travels in comfort and style."
    },
    {
      "name": "Budget Corporate Innova Crysta Taxi Pune",
      "description": "Get the perfect balance of comfort and affordability with our budget corporate Innova Crysta taxi service in Pune. Ideal for startups, SMBs, and recurring business travel, this service ensures cost-effective mobility without compromising on quality."
    },
    {
      "name": "Premium Corporate Innova Crysta Cab Pune",
      "description": "Offer your executives a first-class travel experience with our premium corporate Innova Crysta cabs. Featuring clean interiors, cushioned seats, and attentive service, these rides are designed for comfort during long meetings or tight schedules."
    },
    {
      "name": "Executive Innova Crysta Cab Pune",
      "description": "Book executive-level Innova Crysta cabs in Pune for top-tier corporate travelers. With polished interiors, extra legroom, and chauffeur support, these rides leave a professional impression while ensuring comfort and efficiency."
    },
    {
      "name": "Corporate Transfer Innova Crysta Pune",
      "description": "Ensure smooth corporate transfers across Pune city or to industrial zones and nearby cities. Our Innova Crysta fleet is perfect for employee transfers, top management visits, or board member pickups with prompt and courteous service."
    },
    {
      "name": "Meeting Innova Crysta Cab Pune",
      "description": "Heading to an important meeting? Arrive relaxed and on time with our Innova Crysta cab service. Our chauffeurs plan routes to avoid delays and provide a quiet, professional ride ideal for preparing on the go or debriefing after."
    },
    {
      "name": "Reliable Corporate Innova Crysta Taxi",
      "description": "Trust our reliable corporate taxi service for consistent business travel. With zero last-minute cancellations and live support, we ensure your team or VIP guests always have a dependable ride ready in Pune."
    },
    {
      "name": "Professional Corporate Innova Crysta Cab",
      "description": "Experience professional-grade service with our corporate cab rentals. Our vehicles are GPS-enabled, sanitized regularly, and driven by uniformed chauffeurs—offering a superior travel solution for modern businesses."
    },
    {
      "name": "Corporate Airport Transfer Innova Crysta Pune",
      "description": "Provide seamless airport transfers for your corporate clients or employees. Our Innova Crysta cabs are available 24/7 for pickups and drops at Pune Airport, with luggage assistance, flight tracking, and on-time arrivals guaranteed."
    },
    {
      "name": "Affordable Corporate Innova Crysta Pune",
      "description": "Looking for reliable corporate mobility on a budget? Our affordable Innova Crysta service helps businesses cut costs while maintaining travel comfort for their teams. Custom plans available for daily, monthly, and event-based needs."
    }
  ],
  "tableData": [
    ["Corporate Innova Crysta Cab Pune", "Business Innova Crysta Taxi Pune"],
    ["Office Travel Innova Crysta Pune", "Chauffeur Driven Corporate Innova Crysta Pune"],
    ["Corporate Event Innova Crysta Cab Booking Pune", "Corporate Outstation Innova Crysta Hire Pune"],
    ["Budget Corporate Innova Crysta Taxi Pune", "Premium Corporate Innova Crysta Cab Pune"],
    ["Executive Innova Crysta Cab Pune", "Corporate Transfer Innova Crysta Pune"],
    ["Meeting Innova Crysta Cab Pune", "Reliable Corporate Innova Crysta Taxi"],
    ["Professional Corporate Innova Crysta Cab", "Corporate Airport Transfer Innova Crysta Pune"],
    ["Affordable Corporate Innova Crysta Pune", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Executive Innova Crysta Cab for Corporate Travel",
    "WhyChoosedescription": "Upgrade your corporate transportation with our premium Innova Crysta cabs. Whether it’s client meetings, airport transfers, daily employee commutes, or business tours, we provide a professional, reliable, and luxurious ride tailored to your business needs."
  },
  {
    "WhyChooseheading": "Spacious, Quiet, and Professional Ride Experience",
    "WhyChoosedescription": "Innova Crysta offers plush leather seats, generous legroom, rear AC vents, and a smooth suspension—creating a comfortable and distraction-free environment perfect for executives on the move."
  },
  {
    "WhyChooseheading": "Trained and Courteous Chauffeurs",
    "WhyChoosedescription": "Our drivers are punctual, well-groomed, and trained in corporate etiquette. They ensure a seamless experience with timely arrivals, route optimization, and discreet service for VIP or business travelers."
  },
  {
    "WhyChooseheading": "Ideal for Meetings, Conferences, and Events",
    "WhyChoosedescription": "Need transport for business conferences, trade shows, site visits, or team offsites? Our Innova Crysta cabs are perfect for shuttling teams or clients to important destinations in comfort and style."
  },
  {
    "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Fleet",
    "WhyChoosedescription": "Every vehicle is sanitized before each trip and undergoes regular maintenance. Our fleet maintains high hygiene and performance standards, making it suitable for senior executives and international clients."
  },
  {
    "WhyChooseheading": "Corporate Billing and Flexible Payment Options",
    "WhyChoosedescription": "We offer GST-compliant invoicing, monthly billing, and multiple payment modes to suit your accounting preferences. Whether it’s a one-time trip or ongoing transport solution, we make corporate travel management effortless."
  },
  {
    "WhyChooseheading": "Available for Airport Transfers and Multi-City Travel",
    "WhyChoosedescription": "From Pune to Mumbai Airport transfers to multi-city business tours, our Innova Crysta service ensures reliable intercity connectivity with complete comfort, on-time performance, and zero hassle."
  },
  {
    "WhyChooseheading": "24/7 Corporate Support and Priority Booking",
    "WhyChoosedescription": "Get round-the-clock support with priority booking for corporate accounts. Our dedicated team handles your bookings, reschedules, and emergencies to ensure smooth operations at all times."
  }
]


























    }

const faqData = [
    {
        question: "How can I book an Innova Crysta cab for corporate travel?",
        answer: "You can book by calling Meghana Cab at +91 9075462128 or via our website for a smooth corporate booking experience."
    },
    {
        question: "Is the Innova Crysta suitable for corporate transportation?",
        answer: "Yes, the Innova Crysta offers a professional, comfortable, and spacious ride ideal for corporate clients."
    },
    {
        question: "Can I schedule regular corporate rides with Meghana Cab?",
        answer: "Absolutely, we provide flexible scheduling options for daily or frequent corporate travel."
    },
    {
        question: "How many passengers can the Innova Crysta accommodate for corporate trips?",
        answer: "The Innova Crysta comfortably seats 6 to 7 passengers along with their luggage."
    },
    {
        question: "Are the Innova Crysta cabs sanitized regularly?",
        answer: "Yes, we ensure thorough sanitization before every corporate trip for your safety."
    },
    {
        question: "Do you offer pick and drop services for corporate offices?",
        answer: "Yes, Meghana Cab offers reliable pick and drop services for corporate offices."
    },
    {
        question: "What are the payment options for corporate cab bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, cash, and can arrange corporate billing if needed."
    },
    {
        question: "Can I request additional stops or detours during the trip?",
        answer: "Yes, additional stops can be accommodated. Please inform us at the time of booking."
    },
    {
        question: "Are professional drivers provided for corporate rides?",
        answer: "Yes, our drivers are experienced, well-trained, and maintain professional conduct."
    },
    {
        question: "Is the Innova Crysta cab available 24/7 for corporate clients?",
        answer: "Yes, we provide round-the-clock services tailored for corporate needs."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Rajesh Malhotra',
        designation: 'Corporate Client',
        rating: [1, 1, 1, 1, 1],
        text: '“Reliable and comfortable Innova Crysta cabs for our corporate meetings. Punctual and professional service.”',
    },
    {
        name: 'Ms. Priyanka Shah',
        designation: 'Corporate Client',
        rating: [1, 1, 1, 1, 1],
        text: '“Meghana Cab’s corporate service with Innova Crysta exceeded our expectations. The driver was courteous and the ride smooth.”',
    },
];

























































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];






const corporateInnovaSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Innova Crysta Cab for Corporate Travel in Pune",
  "description": "Premium chauffeur-driven Innova Crysta taxi service for corporate travel in Pune. Ideal for business trips, corporate events, airport transfers, and meetings. Affordable, reliable, and professional corporate cab hire.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Corporate Taxi Service",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/corporate-innova-crysta-cab-pune"
  }
};









    return (
        <div>

<Helmet>
  <title>Corporate Innova Crysta Cab in Pune | Business & Executive Taxi Service</title>
  <meta
    name="description"
    content="Book chauffeur-driven Innova Crysta cabs for corporate travel, business trips, meetings, and airport transfers in Pune. Reliable and affordable corporate taxi service."
  />
  <meta
    name="keywords"
    content="Corporate Innova Crysta Cab Pune, Business Innova Crysta Taxi Pune, Office Travel Innova Crysta Pune, Chauffeur Driven Corporate Innova Crysta Pune, Corporate Event Innova Crysta Cab Booking Pune, Corporate Outstation Innova Crysta Hire Pune, Budget Corporate Innova Crysta Taxi Pune, Premium Corporate Innova Crysta Cab Pune, Executive Innova Crysta Cab Pune, Corporate Transfer Innova Crysta Pune, Meeting Innova Crysta Cab Pune, Reliable Corporate Innova Crysta Taxi, Professional Corporate Innova Crysta Cab, Corporate Airport Transfer Innova Crysta Pune, Affordable Corporate Innova Crysta Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(corporateInnovaSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/25.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Innovacrystacabforcorporate;